import { adminBaseQueryWrapper } from "@/utils/rtkHelper";
import { createApi } from "@reduxjs/toolkit/query/react";

export const purchaseApi = createApi({
  reducerPath: "purchaseApi",
  baseQuery: adminBaseQueryWrapper,
  tagTypes: ["purchase"],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getPurchase: builder.query({
      query: (id) => `/purchase/list/${id}`,
      providesTags: ["purchase"],
    }),
    getPurchaseBySkuId: builder.query({
      query: (id) => `/purchase/sku/${id}`,
      providesTags: ["purchase"],
    }),
    getPurchaseByAccountId: builder.query({
      query: (id) => `/purchase/account/${id}`,
      providesTags: ["purchase"],
    }),
    getPurchaseById: builder.query<any, any>({
      query: (id) => `/purchase/${id}`,
      providesTags: ["purchase"],
    }),
    getPurchaseSummary: builder.query<any, any>({
      query: (id) => `/purchase/list_purchase_summary/${id}`,
      providesTags: ["purchase"],
    }),
    createPurchase: builder.mutation<void, any>({
      query: (input) => ({
        url: `/purchase`,
        method: "POST",
        body: input,
      }),
      invalidatesTags: ["purchase"],
    }),
    updatePurchase: builder.mutation<void, any>({
      query: ({ id, data }) => ({
        url: `/purchase/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["purchase"],
    }),
    deletePurchase: builder.mutation<void, number>({
      query: (id) => ({
        url: `/purchase/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["purchase"],
    }),
    createOpeningStock: builder.mutation<void, any>({
      query: (input) => ({
        url: `/purchase/opening_stock`,
        method: "POST",
        body: input,
      }),
      invalidatesTags: ["purchase"],
    }),
    updateOpeningStock: builder.mutation<void, any>({
      query: (body) => ({
        url: `/purchase/update_stock`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["purchase"],
    }),
    deleteOpeningStock: builder.mutation<{messages: string} , any>({
    query: (payload) => ({
      url: `/purchase/delete_opening`,
      method: "DELETE",
      body: payload,   
    }),
    invalidatesTags: ["purchase"],
  }),


    
  }),
});

export const {
  useGetPurchaseQuery,
  useGetPurchaseByIdQuery,
  useCreatePurchaseMutation,
  useUpdatePurchaseMutation,
  useDeletePurchaseMutation,
  useGetPurchaseBySkuIdQuery,
  useLazyGetPurchaseBySkuIdQuery,
  useGetPurchaseByAccountIdQuery,
  useCreateOpeningStockMutation,
  useUpdateOpeningStockMutation,
  useGetPurchaseSummaryQuery,
  useDeleteOpeningStockMutation
} = purchaseApi;
